var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding":"4rem 0"}},[_c('v-row',[_c('p',{staticStyle:{"font-size":"x-large"}},[_vm._v("Hallo "+_vm._s(_vm.$store.state.authInfo.preName))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }